// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/urn/v1/urn.proto" (package "agency.urn.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * URN represents a parsed session URN.
 * Format: urn.<region>.<kind>.<instance>.<tenant>.<workspace>.<session>.<actor>
 *
 * @generated from protobuf message agency.urn.v1.URN
 */
export interface URN {
    /**
     * raw is the raw URN string.
     *
     * @generated from protobuf field: string raw = 1
     */
    raw: string;
    /**
     * region identifies the geographical or logical region.
     *
     * @generated from protobuf field: string region = 2
     */
    region: string;
    /**
     * kind is the node type (cloud, edge, iot).
     *
     * @generated from protobuf field: string kind = 3
     */
    kind: string;
    /**
     * instance is the harness instance identifier.
     *
     * @generated from protobuf field: string instance = 4
     */
    instance: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 5
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 6
     */
    workspace: string;
    /**
     * session is the session identifier.
     *
     * @generated from protobuf field: string session = 7
     */
    session: string;
    /**
     * actor is the actor component (optional, e.g., "orchestrator", "planner").
     *
     * @generated from protobuf field: string actor = 8
     */
    actor: string;
    /**
     * sub_path contains additional path components for sub-agents.
     *
     * @generated from protobuf field: repeated string sub_path = 9
     */
    subPath: string[];
}
/**
 * URNParseRequest requests URN parsing.
 *
 * @generated from protobuf message agency.urn.v1.URNParseRequest
 */
export interface URNParseRequest {
    /**
     * urn is the URN string to parse.
     *
     * @generated from protobuf field: string urn = 1
     */
    urn: string;
    /**
     * validate performs additional validation checks.
     *
     * @generated from protobuf field: bool validate = 2
     */
    validate: boolean;
}
/**
 * URNParseResponse returns the parsed URN.
 *
 * @generated from protobuf message agency.urn.v1.URNParseResponse
 */
export interface URNParseResponse {
    /**
     * urn is the parsed URN structure.
     *
     * @generated from protobuf field: agency.urn.v1.URN urn = 1
     */
    urn?: URN;
    /**
     * valid indicates if the URN is valid.
     *
     * @generated from protobuf field: bool valid = 2
     */
    valid: boolean;
    /**
     * error_message describes parsing or validation errors.
     *
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
}
/**
 * URNBuildRequest requests URN construction.
 *
 * @generated from protobuf message agency.urn.v1.URNBuildRequest
 */
export interface URNBuildRequest {
    /**
     * region identifies the geographical or logical region.
     *
     * @generated from protobuf field: string region = 1
     */
    region: string;
    /**
     * kind is the node type.
     *
     * @generated from protobuf field: string kind = 2
     */
    kind: string;
    /**
     * instance is the harness instance identifier.
     *
     * @generated from protobuf field: string instance = 3
     */
    instance: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 4
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 5
     */
    workspace: string;
    /**
     * session is the session identifier.
     *
     * @generated from protobuf field: string session = 6
     */
    session: string;
    /**
     * actor is the actor component (optional).
     *
     * @generated from protobuf field: string actor = 7
     */
    actor: string;
    /**
     * sub_path contains additional path components for sub-agents.
     *
     * @generated from protobuf field: repeated string sub_path = 8
     */
    subPath: string[];
}
/**
 * URNBuildResponse returns the constructed URN.
 *
 * @generated from protobuf message agency.urn.v1.URNBuildResponse
 */
export interface URNBuildResponse {
    /**
     * urn is the constructed URN structure.
     *
     * @generated from protobuf field: agency.urn.v1.URN urn = 1
     */
    urn?: URN;
    /**
     * raw is the formatted URN string.
     *
     * @generated from protobuf field: string raw = 2
     */
    raw: string;
}
/**
 * SubAgentURN represents a sub-agent URN extension.
 * Format: <parent-session>.sub.<sub-id>
 *
 * @generated from protobuf message agency.urn.v1.SubAgentURN
 */
export interface SubAgentURN {
    /**
     * parent_urn is the parent session URN.
     *
     * @generated from protobuf field: agency.urn.v1.URN parent_urn = 1
     */
    parentUrn?: URN;
    /**
     * sub_id is the sub-agent identifier.
     *
     * @generated from protobuf field: string sub_id = 2
     */
    subId: string;
    /**
     * depth is the nesting depth (parent = 0, first sub = 1, etc).
     *
     * @generated from protobuf field: int32 depth = 3
     */
    depth: number;
}
/**
 * URNMatchRequest requests URN pattern matching.
 *
 * @generated from protobuf message agency.urn.v1.URNMatchRequest
 */
export interface URNMatchRequest {
    /**
     * urn is the URN to match against.
     *
     * @generated from protobuf field: string urn = 1
     */
    urn: string;
    /**
     * pattern is the match pattern (supports wildcards).
     *
     * @generated from protobuf field: string pattern = 2
     */
    pattern: string;
}
/**
 * URNMatchResponse returns pattern match result.
 *
 * @generated from protobuf message agency.urn.v1.URNMatchResponse
 */
export interface URNMatchResponse {
    /**
     * matches indicates if the URN matches the pattern.
     *
     * @generated from protobuf field: bool matches = 1
     */
    matches: boolean;
    /**
     * matched_components are the components that matched.
     *
     * @generated from protobuf field: map<string, string> matched_components = 2
     */
    matchedComponents: {
        [key: string]: string;
    };
}
// @generated message type with reflection information, may provide speed optimized methods
class URN$Type extends MessageType<URN> {
    constructor() {
        super("agency.urn.v1.URN", [
            { no: 1, name: "raw", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512", pattern: "^urn\\.[a-z0-9-]+\\.[a-z0-9-]+\\.[a-z0-9-]+\\.[a-z0-9-]+\\.[a-z0-9-]+\\.[a-z0-9-]+(\\.[a-z0-9-]+)*$" } } } },
            { no: 2, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "kind", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "instance", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 7, name: "session", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 8, name: "actor", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 9, name: "sub_path", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<URN>): URN {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.raw = "";
        message.region = "";
        message.kind = "";
        message.instance = "";
        message.tenant = "";
        message.workspace = "";
        message.session = "";
        message.actor = "";
        message.subPath = [];
        if (value !== undefined)
            reflectionMergePartial<URN>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URN): URN {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string raw */ 1:
                    message.raw = reader.string();
                    break;
                case /* string region */ 2:
                    message.region = reader.string();
                    break;
                case /* string kind */ 3:
                    message.kind = reader.string();
                    break;
                case /* string instance */ 4:
                    message.instance = reader.string();
                    break;
                case /* string tenant */ 5:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 6:
                    message.workspace = reader.string();
                    break;
                case /* string session */ 7:
                    message.session = reader.string();
                    break;
                case /* string actor */ 8:
                    message.actor = reader.string();
                    break;
                case /* repeated string sub_path */ 9:
                    message.subPath.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URN, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string raw = 1; */
        if (message.raw !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.raw);
        /* string region = 2; */
        if (message.region !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.region);
        /* string kind = 3; */
        if (message.kind !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.kind);
        /* string instance = 4; */
        if (message.instance !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.instance);
        /* string tenant = 5; */
        if (message.tenant !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 6; */
        if (message.workspace !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.workspace);
        /* string session = 7; */
        if (message.session !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.session);
        /* string actor = 8; */
        if (message.actor !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.actor);
        /* repeated string sub_path = 9; */
        for (let i = 0; i < message.subPath.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.subPath[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.urn.v1.URN
 */
export const URN = new URN$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNParseRequest$Type extends MessageType<URNParseRequest> {
    constructor() {
        super("agency.urn.v1.URNParseRequest", [
            { no: 1, name: "urn", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 2, name: "validate", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<URNParseRequest>): URNParseRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.urn = "";
        message.validate = false;
        if (value !== undefined)
            reflectionMergePartial<URNParseRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNParseRequest): URNParseRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string urn */ 1:
                    message.urn = reader.string();
                    break;
                case /* bool validate */ 2:
                    message.validate = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNParseRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string urn = 1; */
        if (message.urn !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.urn);
        /* bool validate = 2; */
        if (message.validate !== false)
            writer.tag(2, WireType.Varint).bool(message.validate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.urn.v1.URNParseRequest
 */
export const URNParseRequest = new URNParseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNParseResponse$Type extends MessageType<URNParseResponse> {
    constructor() {
        super("agency.urn.v1.URNParseResponse", [
            { no: 1, name: "urn", kind: "message", T: () => URN },
            { no: 2, name: "valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<URNParseResponse>): URNParseResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.valid = false;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<URNParseResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNParseResponse): URNParseResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN urn */ 1:
                    message.urn = URN.internalBinaryRead(reader, reader.uint32(), options, message.urn);
                    break;
                case /* bool valid */ 2:
                    message.valid = reader.bool();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNParseResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN urn = 1; */
        if (message.urn)
            URN.internalBinaryWrite(message.urn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool valid = 2; */
        if (message.valid !== false)
            writer.tag(2, WireType.Varint).bool(message.valid);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.urn.v1.URNParseResponse
 */
export const URNParseResponse = new URNParseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNBuildRequest$Type extends MessageType<URNBuildRequest> {
    constructor() {
        super("agency.urn.v1.URNBuildRequest", [
            { no: 1, name: "region", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "kind", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "instance", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 5, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 6, name: "session", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 7, name: "actor", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 8, name: "sub_path", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<URNBuildRequest>): URNBuildRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.region = "";
        message.kind = "";
        message.instance = "";
        message.tenant = "";
        message.workspace = "";
        message.session = "";
        message.actor = "";
        message.subPath = [];
        if (value !== undefined)
            reflectionMergePartial<URNBuildRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNBuildRequest): URNBuildRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string region */ 1:
                    message.region = reader.string();
                    break;
                case /* string kind */ 2:
                    message.kind = reader.string();
                    break;
                case /* string instance */ 3:
                    message.instance = reader.string();
                    break;
                case /* string tenant */ 4:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 5:
                    message.workspace = reader.string();
                    break;
                case /* string session */ 6:
                    message.session = reader.string();
                    break;
                case /* string actor */ 7:
                    message.actor = reader.string();
                    break;
                case /* repeated string sub_path */ 8:
                    message.subPath.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNBuildRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string region = 1; */
        if (message.region !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.region);
        /* string kind = 2; */
        if (message.kind !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.kind);
        /* string instance = 3; */
        if (message.instance !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.instance);
        /* string tenant = 4; */
        if (message.tenant !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 5; */
        if (message.workspace !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.workspace);
        /* string session = 6; */
        if (message.session !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.session);
        /* string actor = 7; */
        if (message.actor !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.actor);
        /* repeated string sub_path = 8; */
        for (let i = 0; i < message.subPath.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.subPath[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.urn.v1.URNBuildRequest
 */
export const URNBuildRequest = new URNBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNBuildResponse$Type extends MessageType<URNBuildResponse> {
    constructor() {
        super("agency.urn.v1.URNBuildResponse", [
            { no: 1, name: "urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "raw", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<URNBuildResponse>): URNBuildResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.raw = "";
        if (value !== undefined)
            reflectionMergePartial<URNBuildResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNBuildResponse): URNBuildResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN urn */ 1:
                    message.urn = URN.internalBinaryRead(reader, reader.uint32(), options, message.urn);
                    break;
                case /* string raw */ 2:
                    message.raw = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNBuildResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN urn = 1; */
        if (message.urn)
            URN.internalBinaryWrite(message.urn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string raw = 2; */
        if (message.raw !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.raw);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.urn.v1.URNBuildResponse
 */
export const URNBuildResponse = new URNBuildResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubAgentURN$Type extends MessageType<SubAgentURN> {
    constructor() {
        super("agency.urn.v1.SubAgentURN", [
            { no: 1, name: "parent_urn", kind: "message", T: () => URN, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "sub_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "depth", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 10, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<SubAgentURN>): SubAgentURN {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subId = "";
        message.depth = 0;
        if (value !== undefined)
            reflectionMergePartial<SubAgentURN>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubAgentURN): SubAgentURN {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.urn.v1.URN parent_urn */ 1:
                    message.parentUrn = URN.internalBinaryRead(reader, reader.uint32(), options, message.parentUrn);
                    break;
                case /* string sub_id */ 2:
                    message.subId = reader.string();
                    break;
                case /* int32 depth */ 3:
                    message.depth = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubAgentURN, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.urn.v1.URN parent_urn = 1; */
        if (message.parentUrn)
            URN.internalBinaryWrite(message.parentUrn, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string sub_id = 2; */
        if (message.subId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subId);
        /* int32 depth = 3; */
        if (message.depth !== 0)
            writer.tag(3, WireType.Varint).int32(message.depth);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.urn.v1.SubAgentURN
 */
export const SubAgentURN = new SubAgentURN$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNMatchRequest$Type extends MessageType<URNMatchRequest> {
    constructor() {
        super("agency.urn.v1.URNMatchRequest", [
            { no: 1, name: "urn", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 2, name: "pattern", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<URNMatchRequest>): URNMatchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.urn = "";
        message.pattern = "";
        if (value !== undefined)
            reflectionMergePartial<URNMatchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNMatchRequest): URNMatchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string urn */ 1:
                    message.urn = reader.string();
                    break;
                case /* string pattern */ 2:
                    message.pattern = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: URNMatchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string urn = 1; */
        if (message.urn !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.urn);
        /* string pattern = 2; */
        if (message.pattern !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pattern);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.urn.v1.URNMatchRequest
 */
export const URNMatchRequest = new URNMatchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class URNMatchResponse$Type extends MessageType<URNMatchResponse> {
    constructor() {
        super("agency.urn.v1.URNMatchResponse", [
            { no: 1, name: "matches", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "matched_components", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<URNMatchResponse>): URNMatchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.matches = false;
        message.matchedComponents = {};
        if (value !== undefined)
            reflectionMergePartial<URNMatchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: URNMatchResponse): URNMatchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool matches */ 1:
                    message.matches = reader.bool();
                    break;
                case /* map<string, string> matched_components */ 2:
                    this.binaryReadMap2(message.matchedComponents, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap2(map: URNMatchResponse["matchedComponents"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof URNMatchResponse["matchedComponents"] | undefined, val: URNMatchResponse["matchedComponents"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.urn.v1.URNMatchResponse.matched_components");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: URNMatchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool matches = 1; */
        if (message.matches !== false)
            writer.tag(1, WireType.Varint).bool(message.matches);
        /* map<string, string> matched_components = 2; */
        for (let k of globalThis.Object.keys(message.matchedComponents))
            writer.tag(2, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.matchedComponents[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.urn.v1.URNMatchResponse
 */
export const URNMatchResponse = new URNMatchResponse$Type();
